// extracted by mini-css-extract-plugin
export default {"planContainer":"xzwgq_xzwgq","root":"n1q2m_n1q2m","header":"H9oi1_H9oi1","headerBox":"HbNIa_HbNIa","switcherContainer":"ZmUvC_ZmUvC","buttonLabel":"Tvyov_Tvyov"};